<div class="standard-panel w-100">
  <h6 class="mb-3">{{ title }}</h6>
  <ng-content></ng-content>
</div>
